import TransmittalService from "@/services/bytepro/transmittal.service";

export const transmittalApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, fileDataId) {
      return TransmittalService.get(fileDataId).then(
        (resp) => {
          commit("dummy", "TransmittalService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "TransmittalService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { transmittal, fileDataId }) {
      return TransmittalService.update(transmittal, fileDataId).then(
        (resp) => {
          commit("dummy", "TransmittalService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "TransmittalService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
